import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {getGFPWaterfallByAPI} from '@web/actions/recommendationProduct'
import {APIStatus} from '@web/core/constants'
import {
    updateAdStatus,
    RecommendationProductAdStatus as AdStatus,
    RecommendationProductState,
    getInitialState,
} from '@web/slices/recommendationProduct/slice'

import {MakeCreateSliceOptions, RecommendationProductReducers} from './interfaces'

const recommendationProductSlice = (options?: MakeCreateSliceOptions) =>
    createSlice<
        RecommendationProductState,
        RecommendationProductReducers,
        'recommendationProduct',
        SliceSelectors<RecommendationProductState>
    >({
        name: 'recommendationProduct',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(getGFPWaterfallByAPI.pending, (state) => {
                    state.apiStatus = APIStatus.FETCHING
                })
                .addCase(getGFPWaterfallByAPI.fulfilled, (state, {payload}) => {
                    state.waterfallResponse = payload
                    state.apiStatus = APIStatus.RESOLVED
                })
                .addCase(getGFPWaterfallByAPI.rejected, (state) => {
                    state.apiStatus = APIStatus.REJECTED
                    state.adStatus = AdStatus.ERROR
                })
                .addCase(updateAdStatus, (state, {payload}) => {
                    state.adStatus = payload
                })
            options?.extraReducers?.(builder)
        },
    })

export default recommendationProductSlice
